var _rect, _circle, _g, _circle2, _g2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgTat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E2F0FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_2979",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#002953"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_2979)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_62_2979",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "#002953"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_62_2979)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0576 8.05762C22.578 7.53729 23.422 7.5373 23.9424 8.05762C24.4627 8.57794 24.4627 9.42206 23.9424 9.94238L9.94238 23.9424C9.42206 24.4627 8.57794 24.4627 8.05762 23.9424C7.5373 23.422 7.53729 22.578 8.05762 22.0576L22.0576 8.05762Z",
    fill: "#005DAC",
    stroke: "#005DAC",
    strokeWidth: 0.477273
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3457 9.3457C10.3631 8.32835 12.0119 8.32835 13.0293 9.3457C14.0467 10.3631 14.0467 12.0119 13.0293 13.0293C12.0119 14.0467 10.3631 14.0467 9.3457 13.0293C8.32835 12.0119 8.32835 10.3631 9.3457 9.3457Z",
    fill: "#88B5DC",
    stroke: "#E2F0FC",
    strokeWidth: 0.477273
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9707 18.9707C19.9881 17.9533 21.6369 17.9533 22.6543 18.9707C23.6717 19.9881 23.6717 21.6369 22.6543 22.6543C21.6369 23.6717 19.9881 23.6717 18.9707 22.6543C17.9533 21.6369 17.9533 19.9881 18.9707 18.9707Z",
    fill: "#88B5DC",
    stroke: "#E2F0FC",
    strokeWidth: 0.477273
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgTat);
export default __webpack_public_path__ + "static/media/AvgTat.6376081783ef42c0a5703d592c3c3344.svg";
export { ForwardRef as ReactComponent };